// extracted by css-extract-rspack-plugin
export default {"cls1":"blurred_takeaways-cls1_XpL","cls2":"blurred_takeaways-cls2_4eU blurred_takeaways-cls1_XpL"};